function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 13a1 1 0 100-2 1 1 0 000 2z",
  fill: "#243143"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM10.592 8.363l6.242-2.496c.816-.327 1.626.483 1.3 1.3l-2.497 6.241a4 4 0 01-2.229 2.229l-6.242 2.496c-.816.327-1.626-.483-1.3-1.3l2.497-6.241a4 4 0 012.229-2.229z",
  fill: "#243143"
});

function SvgCompass24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEzQzEyLjU1MjMgMTMgMTMgMTIuNTUyMyAxMyAxMkMxMyAxMS40NDc3IDEyLjU1MjMgMTEgMTIgMTFDMTEuNDQ3NyAxMSAxMSAxMS40NDc3IDExIDEyQzExIDEyLjU1MjMgMTEuNDQ3NyAxMyAxMiAxM1oiIGZpbGw9IiMyNDMxNDMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMyAxMkMyMyAxOC4wNzUxIDE4LjA3NTEgMjMgMTIgMjNDNS45MjQ4NyAyMyAxIDE4LjA3NTEgMSAxMkMxIDUuOTI0ODcgNS45MjQ4NyAxIDEyIDFDMTguMDc1MSAxIDIzIDUuOTI0ODcgMjMgMTJaTTEwLjU5MTcgOC4zNjMzM0wxNi44MzM2IDUuODY2NThDMTcuNjQ5OSA1LjU0MDA1IDE4LjQ1OTkgNi4zNTAxMyAxOC4xMzM0IDcuMTY2NDVMMTUuNjM2NyAxMy40MDgzQzE1LjIzMDEgMTQuNDI0NyAxNC40MjQ3IDE1LjIzMDEgMTMuNDA4MyAxNS42MzY3TDcuMTY2NDUgMTguMTMzNEM2LjM1MDEzIDE4LjQ1OTkgNS41NDAwNSAxNy42NDk5IDUuODY2NTggMTYuODMzNkw4LjM2MzMzIDEwLjU5MTdDOC43Njk4OSA5LjU3NTI2IDkuNTc1MjYgOC43Njk4OSAxMC41OTE3IDguMzYzMzNaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPgo=";
export { SvgCompass24 as ReactComponent };